import React from "react";
import { Link } from "react-router-dom";
import "./Navbar.scss";
import logo from "../../img/Famoron Logo/horizontal.png";

const Navbar = () => {
  return (
    <header className="header-transparent">
      <nav className="navbar navbar-expand-lg text-center">
        <div className="container">
          <Link to="/" className="navbar-brand">
            <img className="logo" src={logo} alt="famoron logo" />
          </Link>
          <button
            className="navbar-toggler"
            type="button"
            data-toggle="collapse"
            data-target="#navbarSupportedContent"
            aria-controls="navbarSupportedContent"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <span className="navbar-toggler-icon">
              <i className="fi-xwluxl-three-bars-wide"></i>
            </span>
          </button>
          <div className="collapse navbar-collapse" id="navbarSupportedContent">
            <ul className="navbar-nav navbar-nav ml-auto">
              <li className="nav-item">
                <Link to="/" className="nav-link">
                  Home
                </Link>
              </li>
              <li className="nav-item">
                <Link to="/services" className="nav-link">
                  Services
                </Link>
              </li>
              <li className="nav-item">
                <Link to="/works" className="nav-link">
                  Works
                </Link>
              </li>
              <li className="nav-item">
                <a href="https://playbook.famoron.co" className="nav-link">
                  Playbook
                </a>
              </li>
              <li className="nav-item">
                <Link to="/contact" className="nav-link">
                  Contact
                </Link>
              </li>
              <li className="nav-item">
                <Link to="/About" className="nav-link">
                  About
                </Link>
              </li>
            </ul>
          </div>
        </div>
      </nav>
    </header>
  );
};

export default Navbar;
